// The one JSON fetch every screen shares, and the refusal message it throws.

/**
 * Fetches `url` with same-origin credentials and a JSON content type and
 * returns the parsed body. Throws an Error on a non-2xx response whose
 * message is the server's `error` string when the body carries one, so a
 * screen can show the refusal as the server worded it.
 */
export async function fetchJson<T>(
  url: string,
  init?: RequestInit,
): Promise<T> {
  const res = await fetch(url, {
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    ...init,
  });
  if (!res.ok) throw new Error(await refusalOf(res, `${init?.method ?? "GET"} ${url}`));
  return (await res.json()) as T;
}

/**
 * Returns the message a refused response carries: the server's `error`
 * string when the body has one, otherwise `what` and the status. Consumes
 * the body. For fetches that want bytes rather than JSON.
 */
export async function refusalOf(res: Response, what: string): Promise<string> {
  try {
    const b = (await res.json()) as { error?: string };
    if (b?.error) return b.error;
  } catch {
    /* body not JSON */
  }
  return `${what} → ${res.status}`;
}
